<template lang="pug">
  #organization-challenges
    WtTile(vertical).full-height
      WtTitle {{_.get(coreProgramMeta, "organizationsName", "Organization")}} Challenges
      .full-height
        WtTile.organization-challenge-tile.is-flex-direction-column.mb-6(v-for="(challenge, index) in organizationChallenges" :key="challenge.id")
          WtTitle.has-text-centered.mb-1 {{challenge.name}}
          h1.has-text-centered.has-text-weight-bold {{formatDate(challenge.startDate)}} - {{formatDate(challenge.endDate)}}
          BProgress.custom-progress(
            :max="challenge.totalStepsGoal"
            size="is-large"
            :value="getTotalStepsDone(challenge)"
            show-value
            :type="challengeDone(challenge) ? 'is-primary' : 'is-navy'"
          ) {{getTotalStepsDone(challenge).toLocaleString()}}/{{challenge.totalStepsGoal.toLocaleString()}} steps
          h1 Total Steps Goal:
            span.has-text-weight-bold {{" " + challenge.totalStepsGoal.toLocaleString()}}({{distanceFormatter(challenge.totalStepsGoal)}})
          h1 Current Steps Done:
            span.has-text-weight-bold {{" " + getTotalStepsDone(challenge).toLocaleString()}}({{distanceFormatter(getTotalStepsDone(challenge))}})
          h1 Your Steps:
            span.has-text-weight-bold {{" " + getAuthUserTotalStepsDone(challenge).toLocaleString()}}({{distanceFormatter(getAuthUserTotalStepsDone(challenge))}})


</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtStatColumn from "@@/WtStatColumn/WtStatColumn";
import { mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";

export default {
  name: "OrganizationChallenges",

  components: {
    WtTitle,
    WtTile,
    WtStatColumn
  },

  mixins: [dateUtilityMixin],

  props: {},

  computed: {
    ...mapGetters("program", ["coreProgramMeta"]),
    ...mapGetters("organizations", ["organizationChallenges"]),
    ...mapGetters("members", ["member", "memberLoaded"])
  },

  methods: {
    getTotalStepsDone(challenge) {
      let sum = parseInt(
        challenge.organizationMembersStepData.stepsData.allMembers
          .data_activities
      );
      sum += parseInt(
        challenge.organizationMembersStepData.stepsData.allMembers.data_steps
      );

      return sum ? sum : 0;
    },

    getAuthUserTotalStepsDone(challenge) {
      let sum = parseInt(
        challenge.organizationMembersStepData.stepsData.authUser.data_activities
      );
      sum += parseInt(
        challenge.organizationMembersStepData.stepsData.authUser.data_steps
      );
      return sum ? sum : 0;
    },

    stepsToDistance(steps) {
      // Note, 2000 is the generic amount of steps in a mile that WalkerTracker uses
      // Note, 1250 is the generic amount of steps in a kilometer that WalkerTracker uses
      const stepsInUnit =
        this._.get(this.member, "memberData.units", "Miles") === "Miles"
          ? 2000
          : 1250;

      return parseFloat((steps / stepsInUnit).toFixed(2));
    },

    formatDate(date) {
      if (date) {
        return this.date(Date.parse(date), "DATE_FORMAT_SHORT_MONTH").formatted;
      }
      return "";
    },

    distanceFormatter(steps) {
      const unitLabel = this._.get(this.member, "memberData.units", "Miles");
      const distance = this.stepsToDistance(steps);
      return `${distance.toLocaleString()} ${unitLabel}`;
    },

    challengeDone(challenge) {
      if (this.getTotalStepsDone(challenge) >= challenge.totalStepsGoal) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="sass" scoped>
#organization-challenges
  .full-height
    height: 100%
  .custom-progress
    /deep/ .progress, /deep/ .progress-value
      height: 30px
      display: flex
      align-items: center
      font-size: $size-4
      font-family: $family-sans-serif-bold
</style>
